<section id="scDashboard" class="sc-dashboard">
  <div class="sc-dim"></div>

  <div class="sc-dash-inner px-md-5">

    <!-- Identity / header strip -->
    <header class="sc-dash-header">
      <div class="sc-dash-identity">
        <div class="sc-dash-crest">
          <a [routerLink]="" class="sc-avatar-edit" data-bs-toggle="modal" data-bs-target="#avatarModal" style="cursor:pointer" aria-label="Change avatar">
            <img loading="lazy" [src]="'assets/Characters/' + this.user.icon_index + '.webp'" alt="avatar" class="sc-dash-avatar" draggable="false">
            <span class="sc-avatar-gear"><i class="fa-solid fa-gear"></i></span>
          </a>
        </div>
        <div class="sc-dash-id-text">
          <p class="sc-dash-eyebrow">Dashboard</p>
          <h1 class="sc-dash-username">{{this.user.username}}</h1>
        </div>
      </div>

      <div class="sc-dash-header-actions">
        <a routerLink="/" class="sc-dash-home">
          <span class="sc-nav-rhombus"></span>
          <span>Home</span>
        </a>
        @if (sidenavAccount.mode === 'over') {
          <button mat-icon-button (click)="sidenavAccount.toggle()" class="sc-dash-menu-btn" aria-label="Toggle menu">
            <i class="fa-solid fa-bars"></i>
          </button>
        }
      </div>
    </header>

    <mat-sidenav-container class="sc-sidenav-container">
      <mat-sidenav #sidenav1="matSidenav" class="sc-sidenav">
        <div class="sc-sidenav-inner">
          @if (sidenavAccount.mode === 'over') {
            <button type="button" aria-label="Close" (click)="sidenavAccount.toggle()" class="sc-sidenav-close">
              <span aria-hidden="true">&times;</span>
            </button>
          }

          <nav class="sc-nav-section-label">Account</nav>

          <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills sc-nav" orientation="vertical">
            <li [ngbNavItem]="1">
              <a ngbNavLink (click)="closeSidenavIfMobile()">
                <span class="sc-nav-item">
                  <span class="sc-nav-rhombus"></span>
                  <span class="sc-nav-label">Overview</span>
                </span>
              </a>
              <ng-template ngbNavContent>
                <app-account-overview></app-account-overview>
              </ng-template>
            </li>
            <li [ngbNavItem]="2">
              <a ngbNavLink (click)="closeSidenavIfMobile()">
                <span class="sc-nav-item">
                  <span class="sc-nav-rhombus"></span>
                  <span class="sc-nav-label">Account Settings</span>
                </span>
              </a>
              <ng-template ngbNavContent>
                <app-account-settings></app-account-settings>
              </ng-template>
            </li>
            <li [ngbNavItem]="3">
              <a ngbNavLink (click)="closeSidenavIfMobile()">
                <span class="sc-nav-item">
                  <span class="sc-nav-rhombus"></span>
                  <span class="sc-nav-label">Security Settings</span>
                </span>
              </a>
              <ng-template ngbNavContent>
                <app-account-security></app-account-security>
              </ng-template>
            </li>
            <li [ngbNavItem]="4">
              <a ngbNavLink (click)="closeSidenavIfMobile()">
                <span class="sc-nav-item">
                  <span class="sc-nav-rhombus"></span>
                  <span class="sc-nav-label">Orders</span>
                </span>
              </a>
              <ng-template ngbNavContent>
                <app-account-orders></app-account-orders>
              </ng-template>
            </li>
            <li [ngbNavItem]="5">
              <a ngbNavLink (click)="closeSidenavIfMobile()">
                <span class="sc-nav-item">
                  <span class="sc-nav-rhombus"></span>
                  <span class="sc-nav-label">Assistance</span>
                </span>
              </a>
              <ng-template ngbNavContent>
                <app-account-assistance></app-account-assistance>
              </ng-template>
            </li>
          </ul>

          <div class="sc-sidenav-divider"></div>

          <a routerLink="/" class="sc-sidenav-link">
            <span class="sc-nav-rhombus"></span>
            <span>Back to site</span>
          </a>
        </div>

        <div class="sc-toast-area">
          @if (toastStatus === 2) {
            <div class="alert alert-secondary sc-toast" role="alert">
              {{toastMessage}}<br />
              <span class="form-check-label spinner-border spinner-border-sm mr-1 text-primary" style="width:20px;height:20px"></span>
            </div>
          }
          @if (toastStatus === 0) {
            <div class="alert alert-success sc-toast" role="alert">
              Success.<br /> {{toastMessage}}
            </div>
          }
          @if (toastStatus === 1) {
            <div class="alert alert-danger sc-toast" role="alert">
              Fail, try again later.<br /> {{toastMessage}}
            </div>
          }
        </div>
      </mat-sidenav>

      <mat-sidenav-content class="sc-sidenav-content">
        <div class="dash-panel sc-dash-content">
          <div [ngbNavOutlet]="nav"></div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>

  </div>
</section>

<!-- Avatar picker modal: rendered outside #scDashboard so Bootstrap's
     body-level backdrop isn't trapped below the dashboard stacking contexts
     (which previously made the modal unclickable). -->
<div class="modal fade" id="avatarModal" tabindex="-1" aria-labelledby="avatarModalLabel">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title" id="ModalLabel">Choose your avatar</p>
      </div>
      <div class="modal-body">
        <table class="avatar-grid">
          <tr>
            <td>
              <a [routerLink]="" class="avatar-pick" [class.is-selected]="selectedPicId === 0" (click)="SelectPic(0)" style="cursor:pointer" aria-label="Choose avatar 1">
                <img loading="lazy" src="assets/Characters/0.webp" alt="avatar" class="img-fluid" style="width: 250px;" draggable="false">
                <span class="avatar-pick-check"><i class="fa-solid fa-check"></i></span>
              </a>
            </td>
            <td>
              <a [routerLink]="" class="avatar-pick" [class.is-selected]="selectedPicId === 1" (click)="SelectPic(1)" style="cursor:pointer" aria-label="Choose avatar 2">
                <img loading="lazy" src="assets/Characters/1.webp" alt="avatar" class="img-fluid" style="width: 250px;" draggable="false">
                <span class="avatar-pick-check"><i class="fa-solid fa-check"></i></span>
              </a>
            </td>
          </tr>
          <tr>
            <td>
              <a [routerLink]="" class="avatar-pick" [class.is-selected]="selectedPicId === 2" (click)="SelectPic(2)" style="cursor:pointer" aria-label="Choose avatar 3">
                <img loading="lazy" src="assets/Characters/2.webp" alt="avatar" class="img-fluid" style="width: 250px;" draggable="false">
                <span class="avatar-pick-check"><i class="fa-solid fa-check"></i></span>
              </a>
            </td>
            <td>
              <a [routerLink]="" class="avatar-pick" [class.is-selected]="selectedPicId === 3" (click)="SelectPic(3)" style="cursor:pointer" aria-label="Choose avatar 4">
                <img loading="lazy" src="assets/Characters/3.webp" alt="avatar" class="img-fluid" style="width: 250px;" draggable="false">
                <span class="avatar-pick-check"><i class="fa-solid fa-check"></i></span>
              </a>
            </td>
          </tr>
        </table>
      </div>
      <div class="modal-footer">
        <div class="underlineWhite m-auto" data-bs-dismiss="modal" aria-label="Close" style="cursor:pointer">
          <div class="underline">
            <svg height="66px" width="120px">
              <rect class="navicon" id="Rectangle_60" loading="lazy" alt="Icon" width="12px" height="12px" transform="translate(15 33) rotate(-45)" />
              <text x="45px" fill="white" y="40px" style="font-size: 18px; left: 5vw; ">
                <tspan>Cancel</tspan>
              </text>
            </svg>
          </div>
        </div>

        <div class="underlineWhite m-auto" (click)="SaveAvatarPic()" data-bs-dismiss="modal" aria-label="Close" style="cursor:pointer">
          <div class="underline">
            <svg height="66px" width="180px">
              <rect class="navicon" id="Rectangle_60" loading="lazy" alt="Icon" width="12px" height="12px" transform="translate(15 33) rotate(-45)" />
              <text x="45px" fill="white" y="40px" style="font-size: 18px; left: 5vw; ">
                <tspan>Save changes</tspan>
              </text>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
